import { useMutation } from "@tanstack/react-query";
import type { QueryClient } from "@tanstack/react-query";
import type { TApiODIN } from "@/apis/odin/apiODIN";
import type { TSliceNotifications } from "@/store/notifications/sliceNotifications";
import { userKeys } from "@/queries/queryKeys";

export const createUserMutationHooks = ({
    apiODIN,
    queryClient,
    addNotificationWithDefaultTimeout,
}: {
    apiODIN: TApiODIN;
    queryClient: QueryClient;
    addNotificationWithDefaultTimeout: TSliceNotifications["addNotificationWithDefaultTimeout"];
}) => {
    const invalidateUserData = () =>
        queryClient.invalidateQueries({ queryKey: userKeys.all });

    const useSubmitUserConsentMutation = () =>
        useMutation({
            mutationFn: async (consent: boolean) => {
                await apiODIN.setUserConsent({
                    query: { user_consent: consent },
                });
            },
            onSuccess: () => {
                void invalidateUserData();
                addNotificationWithDefaultTimeout({
                    kind: "toast",
                    title: "Terms and conditions accepted",
                    severity: "success",
                });
            },
            onError: () => {
                addNotificationWithDefaultTimeout({
                    kind: "toast",
                    title: "Failed to update user consent",
                    severity: "danger",
                });
            },
        });

    return {
        useSubmitUserConsentMutation,
    };
};

export type TUserMutationHooks = ReturnType<typeof createUserMutationHooks>;
